import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from '../../../services/notifications.service';
import { DEFAULT_ERROR, ERROR_MESSAGES, activeTranslations } from '../../../enum/constants';
import { IError } from '../../../interfaces';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ResetPasswordComponent {
  public emailControl: FormControl;
  public isSending: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly authService: AuthService,
    private readonly notificationService: NotificationService,
  ) {
    this.emailControl = new FormControl(data.data.email || '', [Validators.required, Validators.email]);
  }

  public onSubmit(): void {
    this.isSending = true;

    if (this.emailControl.invalid) {
      this.emailControl.markAsTouched();
      this.isSending = false;
      return;
    }

    this.authService.resetPassword(this.emailControl.value).subscribe({
      next: () => {
        this.isSending = false;
        this.notificationService.showSuccess(
          activeTranslations.notifications_texts.success.success,
          activeTranslations.notifications_texts.success.sent_reset_password,
        );
      },
      error: (e) => {
        this.isSending = false;
        console.log(e);
        (e.error?.errors || []).forEach((err: IError) => {
          this.notificationService.showError(
            activeTranslations.notifications_texts.error.error,
            ERROR_MESSAGES[err.code] || ERROR_MESSAGES[DEFAULT_ERROR],
          );
        });
      },
    });
  }
}
